import { Component, Input, OnInit } from '@angular/core';
import { ILink } from '../models/common-model-interface';
import { Router } from '@angular/router';

@Component({
  selector: 'gn-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  styleUrls: ['./secondary-nav.component.scss']
})
export class SecondaryNavComponent implements OnInit {
  @Input() secondaryNav: Array<ILink>;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  isLinkActive(url: string): boolean {
    return this.removeQueryParamsAndHash(this.router.url) === this.removeQueryParamsAndHash(url);
  }

  private removeQueryParamsAndHash(url) {
    return url.split('?')[0].split('#')[0];
  }
}
